import { useEffect, useState } from "react";
import { IGetRulesListData } from "../types/rules";
import { getPaginatedRulesList } from "../services/rulesService";
import { IPaginatedProps } from "../types";
interface PaginatedRulesProps extends IPaginatedProps {
  searchFilterData?: any;
}

const useFetchPaginatedRules = ({
  currentDomainId,
  setIsLoading,
  page,
  pSize,
  searchFilterData,
}: PaginatedRulesProps) => {
  const [rulesList, setRulesList] = useState<IGetRulesListData[]>([]);
  useEffect(() => {
    setIsLoading(true);
    const fetchRulesList = async () => {
      try {
        const result = await getPaginatedRulesList({
          currentDomainId,
          page,
          pSize,
          searchFilterData,
        });

        setRulesList(result);
      } catch (err) {
        setRulesList([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchRulesList();
  }, [currentDomainId, page, pSize, searchFilterData]);

  return [rulesList];
};

export default useFetchPaginatedRules;
